import { render, staticRenderFns } from "./DepartmentPane.vue?vue&type=template&id=60d07a03&scoped=true"
import script from "./DepartmentPane.vue?vue&type=script&lang=js"
export * from "./DepartmentPane.vue?vue&type=script&lang=js"
import style0 from "./DepartmentPane.vue?vue&type=style&index=0&id=60d07a03&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d07a03",
  null
  
)

export default component.exports